module.exports = __webpack_public_path__ + "img/reflect-02.f3d9a1db.svg";